<div class="container-fluid max-width padded min-height card" [class.fixed-height]="hideDetails" [class.card-selected]="fault?.isSelected" (click)="changeCheck()">
  <!-- defect   -->
  <div *ngIf="windowSize!='xs'" class="hidden-xs col-sm-9 col-md-8 col-lg-8 min-height splitter">
      <ng-container *ngTemplateOutlet="largeView"></ng-container>
  </div>
  <div *ngIf="windowSize=='xs'" class="col-xs-10 hidden-sm hidden-md hidden-lg min-height splitter">
      <ng-container *ngTemplateOutlet="smallView"></ng-container>
  </div>
  <!-- status -->
  <div class="hidden-xs col-sm-3 col-md-4 col-lg-4 min-height">
    <ng-container *ngTemplateOutlet="actionView"></ng-container>
  </div>
  <div class="col-xs-2 hidden-sm hidden-md hidden-lg min-height">
    <ng-container *ngTemplateOutlet="statusView"></ng-container>
  </div>
</div>

<!-- big devices -->
<ng-template #largeView>
  <div *ngIf="layout?.hasImage; else textViewFull">
    <ng-container *ngTemplateOutlet="combinedView"></ng-container>
  </div>
</ng-template>

<!-- small devices -->
<ng-template #smallView>
  <div *ngIf="layout?.hasImage && hideDetails; else textViewFull">
    <ng-container *ngTemplateOutlet="combinedView"></ng-container>
  </div>
</ng-template>


<!-- image and text -->
<ng-template #combinedView>
  <!-- image -->
  <div class="col-xs-4 col-sm-3 col-md-3 min-height">
    <ng-container *ngTemplateOutlet="imageView"></ng-container>
  </div>
  <!-- text -->
  <div class="col-xs-8 col-sm-9 col-md-9 min-height">
    <ng-container *ngTemplateOutlet="textView"></ng-container>
  </div>
</ng-template>

<!-- only text -->
<ng-template #textViewFull>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 min-height">
    <ng-container *ngTemplateOutlet="textView"></ng-container>
  </div>
</ng-template>

<!-- text output -->
<ng-template #textView>
  <div [style.marginLeft]="'10px'">
    <div class="line header" [innerHTML]="header | highlight: fault.search" [class.ellipsed]="hideDetails"></div>
    <ng-container *ngFor="let field of layout.viewProperties; let i=index">
      <ng-container *ngIf="i<2">
        <div class="line caption" [class.ellipsed]="hideDetails">{{field.Label}}:</div>
        <div class="line property" [class.ellipsed]="hideDetails" [innerHTML]="getValueForProperty(field.FieldId) | format | highlight: fault.search"></div>
      </ng-container>
      <ng-container *ngIf="i>1 && !hideDetails">
          <a *ngIf="i==2" href="javascript:;" (click)="toggleDetails();$event.stopPropagation();">
              <span *ngIf="!hideDetails" class='glyphicon glyphicon-chevron-up'></span>
          </a>
          <div class="line caption" [class.ellipsed]="hideDetails">{{field.Label}}:</div>
          <div class="line property" [class.ellipsed]="hideDetails" [innerHTML]="getValueForProperty(field.FieldId) | format | highlight: fault.search"></div>
      </ng-container>
    </ng-container>
    <a href="javascript:;" (click)="toggleDetails();$event.stopPropagation();">
        <span *ngIf="hideDetails" class='glyphicon glyphicon-chevron-down'></span>
        <span *ngIf="!hideDetails" class='glyphicon glyphicon-chevron-up'></span>
      <!-- <img border="0" alt="W3Schools" src="../../../assets/more.png" width="32" height="32"> -->
    </a>
  </div>
</ng-template>

<!-- image output -->
<ng-template #imageView>
  <div  *ngIf="layout?.hasImage " (click)="$event.stopPropagation();" >
    <app-weblink-attachment-list [fault]="fault" (attachmentClick)="onAttachmentClick($event)" ></app-weblink-attachment-list>

    <!-- <img [src]="fault.attachmentUrl" style="display: block;width: 100%;height: 90%; margin-top:1%; object-fit: cover;"> -->
  </div>
  <div *ngIf="!layout?.hasImage"  [style.height.px]="150"
    [style.background]="'url(../../../assets/no_image.png)'" [style.backgroundSize]="'cover'" [style.backgroundRepeat]="'no-repeat'" [style.backgroundPosition]="'50% 50%'" [style.backgroundOrigin]="'padding-box'">
    <input type="checkbox" [style.display]="'none'" [checked]="fault?.isSelected" (change)="changeCheck()" (click)="$event.stopPropagation();" [hidden]="!!fault?.newStatus || !fault.IsEditable || fault.IsClosed"/>
  </div>
</ng-template>

<!-- action large -->
<ng-template #actionView>
  <div [style.marginLeft]="'10px'">
    <div class="line header" style="display: flex; align-items: center; gap: 5px">
      <span>{{ 'weblink.misc.action' | translate }}:</span>
      <span *ngIf="fault?.faultState===FaultState.synced || fault?.faultState===FaultState.cannotEdit"  class="glyphicon glyphicon-ok" [style.fontSize]="'22px'"></span>
      <img *ngIf="fault?.IsClosed" src="../../../assets/unavailable.svg" style="color: red; width: 22px; height: 22px">
      <span *ngIf="fault?.IsClosed" style="font-size: 14px;font-weight: normal; margin-left: 10px">{{ 'weblink.misc.lockedForEdit' | translate }}</span>
    </div>
    <ng-container *ngIf="fault?.faultState===FaultState.cannotEdit||fault?.faultState===FaultState.mustUpload || fault?.faultState===FaultState.synced || fault?.IsClosed" >
      <div class="line caption">{{ 'weblink.edit.status' | translate }}:</div>
      <div class="line property ellipsed">
        <span *ngIf="fault?.newStatus">
          <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault?.newStatus?.Name1}} - {{fault?.newStatus?.Name2}}</a>
        </span>
        <span *ngIf="fault?.Activities?.length>0 && !fault?.newStatus && !fault?.IsClosed">
          <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault.Activities[0].Status.Name1}} - {{fault.Activities[0].Status.Name2}} (vom {{dateToLocalDate(fault.Activities[0].Date)}})</a>
        </span>
        <span *ngIf="fault?.closedActivity && !!fault?.IsClosed">
          <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault.closedActivity.Status?.Name1}} - {{fault.closedActivity.Status?.Name2}} (vom {{dateToLocalDate(fault.closedActivity.Date)}})</a>
        </span>
      </div>
      <div class="line caption">{{ 'weblink.edit.remarks' | translate }}:</div>
      <div class="line property ellipsed">
        <span *ngIf="fault?.newStatus">
          <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault?.newText}}</a>
        </span>
        <span *ngIf="fault?.Activities?.length>0 && !fault?.newStatus && !fault?.IsClosed">
            <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault.Activities[0].Description}}</a>
        </span>
        <span *ngIf="fault?.closedActivity && !!fault?.IsClosed">
<!--            <span >{{fault.closedActivity.Description}}</span>-->
            <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">{{fault.closedActivity.Description}}</a>
        </span>
      </div>
      <!-- <div class="line caption">Datei:</div>
      <div class="line property ellipsed">{{fault?.newFile?.name}}
      </div> -->
    </ng-container>
    <ng-container *ngIf="fault?.faultState===FaultState.uploadingActivity">
      <div class="col-xs-12 text-center">
        <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
        {{ 'weblink.progress.createActivity' | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="fault?.faultState===FaultState.uploadingAttachment">
      <div class="col-xs-12 text-center">
        <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
        {{ 'weblink.progress.uploadFile' | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorActivity">
      <div class="line text-center">
          <span class="glyphicon glyphicon-remove" [style.fontSize]="'22px'"></span>
      </div>
      <div class="line text-center">
          <span> {{ 'weblink.error.createActivity' | translate }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorAttachment">
      <div class="col-xs-12 text-center">
        <span class="glyphicon glyphicon-remove" [style.fontSize]="'22px'"></span>
      </div>
      <div class="col-xs-12 text-center">
        <span> {{ 'weblink.error.uploadFile' | translate }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="fault?.faultState===FaultState.canEdit && !fault?.IsClosed">
      <div class="line text-center">
          <a href="javascript:;" (click)="$event.stopPropagation();edit(fault);">
            <span class='glyphicon glyphicon-pencil' [style.fontSize]="'22px'"></span><span> {{ 'weblink.button.edit' | translate }}</span>
          </a>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- action small -->
<ng-template #statusView>
    <div class="status-view">
      <!-- <div class="line header">Aktion:</div> -->
      <ng-container *ngIf="fault?.faultState===FaultState.cannotEdit||fault?.faultState===FaultState.mustUpload || fault?.faultState===FaultState.synced">
          <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">
              <span class="glyphicon glyphicon-ok"></span>
          </a>
      </ng-container>
      <ng-container *ngIf="fault?.faultState===FaultState.uploadingActivity">
        <div class="col-xs-12 text-center">
          <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
        </div>
      </ng-container>
      <ng-container *ngIf="fault?.faultState===FaultState.uploadingAttachment">
        <div class="col-xs-12 text-center">
          <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
        </div>
      </ng-container>
      <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorActivity">
        <span class="glyphicon glyphicon-remove"></span>
      </ng-container>
      <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorAttachment">
        <span class="glyphicon glyphicon-remove"></span>
      </ng-container>
      <ng-container *ngIf="fault?.faultState===FaultState.canEdit && !fault?.IsClosed">
      <a href="javascript:;" (click)="$event.stopPropagation();edit(fault);">
        <span class='glyphicon glyphicon-pencil'></span>
      </a>


      <!-- <div class="col-xs-12 text-center">
        <button class="btn btn-default" (click)="$event.stopPropagation();edit(fault);">
          <span class="glyphicon glyphicon-flag"></span> Bearbeiten
        </button>
      </div> -->
    </ng-container>
      <ng-container *ngIf="fault?.closedActivity && !!fault?.IsClosed">
        <a href="javascript:;" (click)="$event.stopPropagation();show(fault);">
          <span class='glyphicon glyphicon-ban-circle' style="color: red"></span>
        </a>
      </ng-container>


    </div>
  </ng-template>
